<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar elevation-4 sidebar-dark-marron">
        <a href="#" class="brand-link animation__shake wow fadeInDown"
            style="align-items: center;position: absolute;top: 25px;" data-widget="pushmenu" role="button">
            <center>
                <i class="fas fa-align-right text-white"></i>&nbsp;<img src="../../../assets/img/logojateng.png"
                    alt="Admin Logo" class="animation__shake wow fadeInDown" style="opacity: .8;height: 35px;">
            </center>
        </a>
        <!-- Sidebar -->
        <div class="sidebar wow fadeInLeft">
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar  nav-child-indent flex-column nav-flat" data-widget="treeview"
                    role="menu" data-accordion="false">
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">
                        <router-link to="/Dashboard"
                            :class="[(route.name == 'Dashboard' ? 'nav-link active' : 'nav-link')]" id="Dashboard"><i
                                class="nav-icon fas fa-chart-line"></i>
                            <p class="text-white" style="font-weight: bolder;">DASHBOARD</p>
                        </router-link>
                    </li>
                    <li class="nav-item" style="display: none;">
                        <router-link to="/Kegiatan"
                            :class="[(route.name == 'Kegiatan' || route.name == 'ProsesKegiatan' ? 'nav-link active' : 'nav-link')]"
                            id="Kegiatan"><i class="nav-icon far fa-building"></i>
                            <p class="text-white" style="font-weight: bolder;">KEGIATAN CISP</p>
                        </router-link>
                    </li>
                    <li style="display: none;" :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'Procurement' || route.name == 'ProsesProcurement'
                        || route.name == 'Finance' || route.name == 'ProsesFinance' || route.name == 'Social' || route.name == 'ProsesSocial'
                        || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Gesiap' || route.name == 'ProsesGesiap'
                        || route.name == 'Program' || route.name == 'ProsesProgram'
                    ) ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#"
                            :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'Procurement' || route.name == 'ProsesProcurement'
                                || route.name == 'Finance' || route.name == 'ProsesFinance' || route.name == 'Social' || route.name == 'ProsesSocial'
                                || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Gesiap' || route.name == 'ProsesGesiap'
                                || route.name == 'Program' || route.name == 'ProsesProgram') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-server"></i>
                            <p class="text-white" style="font-weight: bolder;">
                                MONITORING
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item"
                                v-if="leveluser == 1 || leveluser == 4 || leveluser == 3 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Program"
                                    :class="[((route.name == 'Program' || route.name == 'ProsesProgram') ? 'nav-link active' : 'nav-link')]"
                                    id="Program"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PROGRAM & BUDGETING</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="leveluser == 1 || leveluser == 7 || leveluser == 3 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Procurement"
                                    :class="[((route.name == 'Procurement' || route.name == 'ProsesProcurement') ? 'nav-link active' : 'nav-link')]"
                                    id="Procurement"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PROCUREMENT</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="leveluser == 1 || leveluser == 2 || leveluser == 3 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Finance"
                                    :class="[((route.name == 'Finance' || route.name == 'ProsesFinance') ? 'nav-link active' : 'nav-link')]"
                                    id="Finance"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">FINANCE</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 || leveluser == 5 || leveluser == 3 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Social"
                                    :class="[((route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-link active' : 'nav-link')]"
                                    id="Social"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">SOCIAL SAFEGUARD</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 || leveluser == 6 || leveluser == 3 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Environment"
                                    :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment') ? 'nav-link active' : 'nav-link')]"
                                    id="Environment"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">ENVIRONMENT SAFEGUARD</p>
                                </router-link>
                            </li>
                            <li class="nav-item" style="display: none;">
                                <router-link to="/Monev"
                                    :class="[((route.name == 'Monev' || route.name == 'ProsesMonev') ? 'nav-link active' : 'nav-link')]"
                                    id="Monev"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">MONEV</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 || leveluser == 5 || leveluser == 9">
                                <router-link to="/Gesiap"
                                    :class="[((route.name == 'Gesiap' || route.name == 'ProsesGesiap') ? 'nav-link active' : 'nav-link')]"
                                    id="Gesiap"><i class="nav-icon far fa-circle"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GENDER ACTION PLAN</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 5 || leveluser == 8 || leveluser == 9" style="display: none;">
                        <router-link to="/AduanMasyarakat"
                            :class="[(route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat' ? 'nav-link active' : 'nav-link')]"
                            id="Kegiatan"><i class="nav-icon fab fa-adn"></i>
                            <p class="text-white" style="font-weight: bolder;">DATA ADUAN</p>
                        </router-link>
                    </li>
                    <li :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider' || route.name == 'SettingMenu'
                        || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                        || route.name == 'Konten' || route.name == 'ProsesKonten'
                        || route.name == 'Berita' || route.name == 'ProsesBerita'
                        || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                        || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                        || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                        || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                        || route.name == 'DataDokumen') ? 'nav-item menu-open' : 'nav-item')]" v-if="leveluser == 1">
                        <a href="#" :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider' || route.name == 'SettingMenu'
                            || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                            || route.name == 'Konten' || route.name == 'ProsesKonten'
                            || route.name == 'Berita' || route.name == 'ProsesBerita'
                            || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                            || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                            || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                            || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                            || route.name == 'DataDokumen') ? 'nav-link active' : 'nav-link')]" v-if="leveluser == 1">
                            <i class="nav-icon fas fa-tablets"></i>
                            <p class="text-white" style="font-weight: bolder;">
                                PENGATURAN
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="leveluser == '1'">
                                <router-link to="/InfoBeranda"
                                    :class="[((route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]"
                                    id="InfoBeranda"><i class="nav-icon fas fa-box"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">INFO BERANDA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == '1'">
                                <router-link to="/Konten"
                                    :class="[((route.name == 'Konten' || route.name == 'ProsesKonten') ? 'nav-link active' : 'nav-link')]"
                                    id="Konten"><i class="nav-icon fas fa-book"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KONTEN WEB</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == '1'">
                                <router-link to="/Slider"
                                    :class="[((route.name == 'Slider' || route.name == 'ProsesSlider') ? 'nav-link active' : 'nav-link')]"
                                    id="Slider"><i class="nav-icon fas fa-cogs"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">HEADER DAN TEXT</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Berita"
                                    :class="[((route.name == 'Berita' || route.name == 'ProsesBerita') ? 'nav-link active' : 'nav-link')]"
                                    id="Berita"><i class="nav-icon fas fa-bold"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">BERITA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Galeri"
                                    :class="[((route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri') ? 'nav-link active' : 'nav-link')]"
                                    id="Galeri"><i class="nav-icon fas fa-photo-video"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GALERI</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/DataDokumen"
                                    :class="[((route.name == 'DataDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="DataDokumen"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">DOKUMEN</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == '1'" style="display: none;">
                                <router-link to="/LayerPeta"
                                    :class="[((route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta') ? 'nav-link active' : 'nav-link')]"
                                    id="LayerPeta"><i class="nav-icon fas fa-layer-group"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">LAYER PETA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == '1'" style="display: none;">
                                <router-link to="/SettingMenu"
                                    :class="[((route.name == 'SettingMenu' || route.name == 'ProsesSettingMenu') ? 'nav-link active' : 'nav-link')]"
                                    id="SettingMenu"><i class="nav-icon fas fa-eye"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">SETTING MENU</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == '1'">
                                <router-link to="/User"
                                    :class="[((route.name == 'User' || route.name == 'ProsesUser') ? 'nav-link active' : 'nav-link')]"
                                    id="User"><i class="nav-icon fas fa-user-friends"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PENGGUNA</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link" @click="keluar()">
                            <i class="nav-icon fas fa-sign-out-alt"></i>
                            <p class="text-white" style="font-weight: bolder;">KELUAR / LOGOUT</p>
                        </a>
                    </li>

                    <li>&nbsp;</li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
    components: {
        swal
    },
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            folderawal: encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                localStorage.removeItem('tokensistem');
                localStorage.removeItem('usistem');
                localStorage.removeItem('lsistem');
                localStorage.removeItem('inssistem');
                localStorage.removeItem('rlsistem');
                localStorage.removeItem('nmlsistem');
                localStorage.removeItem('emlsistem');
                localStorage.removeItem('nmusistem');
                localStorage.removeItem('tsistem');
                localStorage.removeItem('orsistem');
                localStorage.removeItem('bdlsistem');
                localStorage.removeItem('sbdsistem');
                localStorage.removeItem('jbtsistem');
            }
        },
        pindahawalnya1() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data/" + bytes);
        },
        pindahawalnya3() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data3/" + bytes);
        },
        pindahawalnya4() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data4/" + bytes);
        },
        pindahawalnya5() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data5/" + bytes);
        },
        pindahawalnya6() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data6/" + bytes);
        },
        pindahawalnya7() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data7/" + bytes);
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3D405B",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorage();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if ((localStorage.getItem("tokensistem") == null)) {
            window.location.replace("/");
        }
    }
}
</script>

<style></style>